import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import axios from 'axios'

const EditTeacherModal = ({ show, handleClose, teacher }) => {
  const [updatedTeacher, setUpdatedTeacher] = useState({
    name: '',
    dob: '',
    qualification: '',
    phone: '',
    email: '',
    // status: '',
    gender: '',
    address: '',
    password: '',
    joining_date: '',
  })
  const [teacherImage, setTeacherImage] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  useEffect(() => {
    if (teacher) {
      setUpdatedTeacher({
        class_name: teacher.class_name || '',
        name: teacher.name || '',
        dob: teacher.dob || '',
        qualification: teacher.qualification || '',
        phone: teacher.phone || '',
        email: teacher.email || '',
        password: teacher.password || '',
        // status: '',
        gender: teacher.gender || '',
        address: teacher.address || '',
        joining_date: teacher.joining_date || '',
      })
    }
  }, [teacher])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedTeacher((prev) => ({ ...prev, [name]: value }))
    console.log(`Updated ${name}:`, value) // Debugging
  }

  const handleSaveChanges = async () => {
    console.log('Sending updated data:', updatedTeacher) // Debugging

    try {
      let imageUrl = null
      if (teacherImage) {
        if (teacherImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }
        const formData = new FormData()
        formData.append('image', teacherImage)
        formData.append('folder', 'teacher')
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }
        const imageResponse = await axios.post(
          BASE_URL+'/upload-image',
          formData,
        )
        imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        console.log('IMGURL', imageUrl)
      }
      const updatedData = {
        ...updatedTeacher,
        teacher_image: imageUrl,
      }
      console.log('Sending data: ', updatedData)

      const response = await ApiEndpoints.editTeacher(teacher.id, updatedData)
      toast.success(response.data.message)
      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Teacher</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Name Field */}
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={updatedTeacher.name}
              onChange={handleInputChange}
              placeholder="Enter Teacher's Name"
              className="p-2 border rounded"
            />
          </Form.Group>

          {/* Date of Birth Field */}
          <Form.Group className="mb-3">
            <Form.Label>Date of Birth</Form.Label>
            <Form.Control
              type="date"
              name="dob"
              value={updatedTeacher.dob}
              onChange={handleInputChange}
              className="p-2 border rounded"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Gender</Form.Label>
            <Form.Select
              name="gender"
              value={updatedTeacher.gender}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </Form.Select>
          </Form.Group>

          {/* Qualification Field */}
          <Form.Group className="mb-3">
            <Form.Label>Qualification</Form.Label>
            <Form.Control
              type="text"
              name="qualification"
              value={updatedTeacher.qualification}
              onChange={handleInputChange}
              placeholder="Enter Qualification"
              className="p-2 border rounded"
            />
          </Form.Group>

          {/* Phone Number Field */}
          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={updatedTeacher.phone}
              onChange={handleInputChange}
              placeholder="Enter Phone Number"
              className="p-2 border rounded"
            />
          </Form.Group>

          {/* Email ID Field */}
          <Form.Group className="mb-3">
            <Form.Label>Email ID</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={updatedTeacher.email}
              onChange={handleInputChange}
              placeholder="Enter Email ID"
              className="p-2 border rounded"
            />
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <div className="input-group">
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={updatedTeacher.password}
                onChange={handleInputChange}
                placeholder="Enter Password"
                className="p-2 border rounded"
              />
              <Button
                variant="outline-secondary"
                onClick={togglePasswordVisibility}
                title={showPassword ? 'Hide Password' : 'Show Password'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </div>
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label>Date of Join</Form.Label>
            <Form.Control
              type="date"
              name="joining_date"
              value={updatedTeacher.joining_date}
              onChange={handleInputChange}
              className="p-2 border rounded"
            />
          </Form.Group>

          {/* Address Field */}
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="address"
              value={updatedTeacher.address}
              onChange={handleInputChange}
              placeholder="Enter Address"
              className="p-2 border rounded"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Student Image (PNG/JPG/JPEG)</Form.Label>

            <div className="d-flex align-items-center gap-3 mt-2 mb-2">
              <Form.Control
                type="file"
                accept="teacher_image/png, teacher_image/jpeg, teacher_image/jpg"
                onChange={(e) => setTeacherImage(e.target.files[0])}
                style={{ maxWidth: '700px' }}
              />
              {teacherImage && (
                <img
                  src={URL.createObjectURL(teacherImage)}
                  alt="Preview"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: 8,
                    border: '1px solid #ccc',
                  }}
                />
              )}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditTeacherModal
